import { render, staticRenderFns } from "./mfa-app.vue?vue&type=template&id=0983de9d&scoped=true&"
import script from "./mfa-app.vue?vue&type=script&lang=js&"
export * from "./mfa-app.vue?vue&type=script&lang=js&"
import style0 from "./mfa-app.vue?vue&type=style&index=0&id=0983de9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983de9d",
  null
  
)

export default component.exports